<div class="component-frame">
  <p>
    Login failed. Please try again.
  </p>
</div>
